let $ = jQuery;

class TextFields {

  constructor() {
    this.$formItems = $(".js-form-item");
    this.activeClass = "js-textfield-focused";
    this.fields = [];
    this.highlight = "<span class='form-highlight'></span>";
    this.enabledClass = "js-textfield-enabled";
    this.populatedClass = "js-textfield-populated";
    this.$animTextFields;

    if (this.$formItems.length > 0) {
      this.setupFields();
    }
  }

  /*
    Adds necessary classes to the fields.
    Appends a little DOM for the sake of decoration.
    Then stores items as a jQuery variable for ease of manipulation and then calls
    the bind function.
  */
  setupFields() {

    $.each(this.$formItems, (index, elem) => {
      let $elem = $(elem);

      if (this.shouldBeAnimated($elem)) {

        $elem.children(".form-item__inner").append(this.highlight);
        $elem.addClass(this.enabledClass);
        if ($elem.find("input.password").val() !== undefined) {
          $elem.addClass(this.populatedClass);
        }
        // Check if it is prepopulated.
        if ($elem.find("input").val().length > 0) {
          $elem.addClass(this.populatedClass);
        }
        // If the page loads and this element is already focused.
        if ($elem.find('input').is(':focus')) {
          $elem.addClass(this.activeClass);
        }

        this.fields.push($elem);
      }
    });

    this.$animTextFields = $("." + this.enabledClass + " input");

    this.bindEvents();
  }

  bindEvents() {

    // Focus.
    this.$animTextFields.on('focus', (e) => {
      let $target = $(e.currentTarget);
      let $parent = $target.parents('.js-form-item');

      $parent.addClass(this.activeClass);
    });

    // Blur.
    this.$animTextFields.on('blur', (e) => {
      let $target = $(e.currentTarget);
      let $parent = $target.parents('.js-form-item');

      // Check if it's populated.
      if ($target.val().length > 0) {
        $parent.addClass(this.populatedClass);
      }
      else {
        $parent.removeClass(this.populatedClass);
      }

      $parent.removeClass(this.activeClass);
    });
  }

  /*
    Checks if a given element has the correct class, is not already in our array
    and has a label and that label is visible.
  */
  shouldBeAnimated($elem) {
    var anim = false;
    var fieldTypes = [
      "form-type-textfield",
      "form-type-text",
      "form-type-password",
      "form-type-datetime",
      "form-type-datetime-local",
      "form-type-month",
      "form-type-week",
      "form-type-email",
      "form-type-number",
      "form-type-search",
      "form-type-tel",
      "form-type-time",
      "form-type-url",
      "form-type-color"
    ];
    var i = fieldTypes.length - 1;

    // The element should have one of the stored class names on it.
    for (i; i >= 0; i--) {
      if ($elem.hasClass(fieldTypes[i]) && this.fields.indexOf($elem) < 0) {
        anim = true;
      }
    }

    // If the element does not have a label or it has one but it is hidden,
    // we should not apply any of this.
    if ($elem.find("label").length < 1 ||
        $elem.find("label").hasClass("visually-hidden") ||
        $elem.find("label").css("display") == "none"
      ) {

      anim = false;
    }

    return anim;
  }
}

function init() {

  let textFields = new TextFields();
}

if (typeof Drupal === 'undefined') {

  // Initialize for Styleguide
  $(document).ready(() => {
    init();
  });
}
else {

  // Export for Drupal
  module.exports = {

    attach: function (context, settings) {

      // if (context !== document) {
      //   return;
      // }
      // else {
        init();
      // }
    }
  };
}
